import { ChangeEvent, MouseEvent } from 'react';
import { ControllerProps, passwordRequirements, useControllerWithEventHandler } from '@mews/framework';
import { InputValue, PasswordInput, PasswordInputProps } from '@optimus-web/core';

export type PasswordFieldProps = Omit<PasswordInputProps, 'value' | 'error' | 'onBlur' | 'passwordStrength'> &
    ControllerProps & {
        showPasswordStrength?: boolean;
    };

export const PasswordField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    showPasswordStrength,
    transform,
    ...other
}: PasswordFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });

    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: (event: ChangeEvent<HTMLInputElement> | MouseEvent, pw: InputValue) => handleChange(event, pw),
        value,
        passwordStrength: showPasswordStrength ? passwordStrength : undefined,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <PasswordInput {...props} />;
};

const passwordStrength = {
    requirements: passwordRequirements,
};
